import React from 'react';
import {Button, Col, Row, Typography} from "antd";
import {GLOBAL_CONFIG} from "../tools/global_config";
import {track} from "@amplitude/analytics-browser";

const { Title, Text } = Typography;

const FeedbackPanel = () => {
    const openInNewTab = url => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <div
            style={{
                textAlign: "left"
            }}
        >
            <Col>
                <Row>
                    <Title
                        level={5}
                        style={{marginTop: 16, marginBottom: 16, marginLeft: 24, float: "left"}}
                    >
                        We would love to hear from you
                    </Title>
                </Row>
                <Row>
                    <Text style={{marginLeft: 24, marginRight: 16, marginBottom: 16}}>
                        Please, share your feedback and we will improve our services for you ❤️
                    </Text>
                </Row>
                <Row>
                    <Button
                        type="primary"
                        style={{marginLeft: 48, marginRight: 48, width: "100%", marginBottom: 32, height: 40, borderRadius: 8}}
                        onClick={() => {
                            track("feedback_clicked");
                            openInNewTab(GLOBAL_CONFIG.survey_url);
                        }}
                    >
                        Share feedback
                    </Button>
                </Row>
            </Col>
        </div>
    );
};

export default FeedbackPanel;